<template>
  <form-item v-bind="$attrs" v-on="$listeners">
    <el-input-number v-bind="$attrs"
                     v-on="$listeners"
                     v-model="model[$attrs.prop]"
                     controls-position="right"
                     :step="1"
                     :min="0"
                     :max="100"
                     step-strictly
                     class="fullwidth">
    </el-input-number>
  </form-item>
</template>

<script>
  import FormItem from '@/components/form/FormItem'

  export default {
    name: 'InputNumberFormItem',
    components: { FormItem },
    computed: {
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>
